export default "__VITE_ASSET__DiMZ9LoS__"